module.exports = __webpack_public_path__ + "static/media/ifind-logo-vaaka.a7733d0c.png";